import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
import { v_InventoryBus } from './v_InventoryBus';
import { v_LocationDetailBus } from './v_LocationDetailBus';

/* 
 *AddToOrder? (is ui interactive)
 * Part Number: number
 * Summary: inventoryDesc
 * Full Description: fullDescription
 * From Warehouse: inventoryLocationName
 * Qty In Stock: qtyInStock
 * Used Qty: usedPartQuantity
 * Resource: personName
 * Last Supplier: lastSupplier
 * Date : addedDate
 * Part Used: isXfered
 * Wrong Part: isWrongPart
 * Replace: needsReplacement
 */
export class v_DispatchPartsRequestedBus extends BaseBus
{
    constructor(busObj: v_DispatchPartsRequestedBus = null) {
        super(busObj);
        this.insertDt = DateFunctions.getDate(this.insertDt);
        this.updateDt = DateFunctions.getDate(this.updateDt);
        this.addedDate = DateFunctions.getDate(this.addedDate);
        this.sageDt = DateFunctions.getDate(this.sageDt);
    }
    CID(): any {
        return this.dispatchPartsRequestId;
    }
    setId(id: any) {
        this.dispatchPartsRequestId = id;
    }
    setParentId(id: any) {
        this.dispatchId = id;
    }
    setFromForm(busObj: any) {
        super.setFromForm(busObj);
        this.inventoryLocationId = this.fromInventoryLocationId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: v_LocationDetailBus = null) {
        this.quantity = 1;
        this.personId = personId;
        this.addedDate = new Date(date);
        this.fromInventoryLocationId = other.inventoryLocationId;
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!DateFunctions.isValidDate(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    changeInventoryItem(data: v_InventoryBus) {
        this.number = data.number;
        this.inventoryDesc = data.inventoryDesc;
        this.inventoryId = data.inventoryId;
        this.fullDescription = data.fullDescription;
        
        //this.quantity = 1;
        //this.qtyInStock = data..currentCost;
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }

  dispatchPartsRequestId: any;
  quantity: number;
  addedDate: Date;
  inventoryLocationId: any;
  inventoryDesc: string;
  number: string;
  personName: string;
  currentCost: number;
  lastCost: number;
  flatCost: number;
  ratio: number;
  internationalCost: number;
  qtyToXfer: number;
  isXfered: Boolean;
  qtyInStock: number;
  isWrongPart: Boolean;
  manufacturerNumber: string;
  viewedInMobile: Boolean;
  usedPartQuantity: number;
  inventoryLocationName: string;
  fromInventoryLocationId: any;
  avgCost: number;
  needsReplacement: Boolean;
  fullDescription: string;
  lastSupplier: string;
  onConstDraw: Boolean;
  sageDt: Date;
  dispatchId: any;
  personId: any;
  inventoryId: any;
  addToOrder: boolean; //used to add
  insertDt: Date;
  insertUserId: any;
  updateDt: Date;
    updateUserId: any;
    warehouse: string;
    row: string;
    bay: string;
    bin: string;
    locationQuantity: number;
    allQuantity: number;
}
